<template src="../template/follow.html"></template>

<script>
import Vue from 'vue'
import _ from 'lodash'
import { mapState, mapGetters, mapMutations } from 'vuex'
import VueYoutube from 'vue-youtube'
import { getCookie } from '../utils/cacheUtil'
import { LS_DEVICE_FINGER_PRINT_KEY } from '../utils/fingerPringUtil'
import { LMap, LMarker, LPopup, LTileLayer, LTooltip } from 'vue2-leaflet'
import { uuid } from 'vue-uuid'

Vue.use(VueYoutube)

export default {
  name: 'follow',
  components: {
    LMap,
    LTileLayer,
    LMarker,
    LPopup,
    LTooltip
  },
  computed: {
    ...mapState(['PROJECT_ID', 'QR_CODE', 'EXT_CUSTOM_PUB_UTILS', 'ALL_MARKERS', 'SHOW_LOCAL_NAME', 'GUIDE_LIST']),
    ...mapGetters(['getProjectId', 'getQRCode', 'getExtCustomPubUtils', 'getAllMarkers', 'getShowLocalName', 'getGuides'])
  },
  created () {
    const prjId = this.$route.params.prjId
    this.prjId = this.$route.params.prjId
    const currentGuideId = this.$route.params.guideId
    window.localStorage.setItem('PROJECT_ID', prjId)
    if (window.localStorage.getItem('gpsTimeID') !== null) {
      clearInterval(parseInt(window.localStorage.getItem('gpsTimeID')))
      window.localStorage.removeItem('gpsTimeID')
    }
    // startToWatchGps()
    // // sendGeoLocation(this.getProjectId, this.getQRCode, 'Follow')
    // const timeoutID = window.setInterval(
    //   () => {
    //     sendGeoLocation(this.getProjectId, this.getQRCode, 'Follow')
    //   }, 30000
    // )
    // window.localStorage.setItem('gpsTimeID', timeoutID)
    if (!_.isNil(prjId) && (prjId !== '822b5299-7d52-4520-ab0b-8d5a0c286298') && (_.isNull(this.getQRCode) || _.isNull(window.localStorage.getItem('userId')))) {
      this.$swal({
        title: '您尚未使用個人帳號登入',
        text: '系統將自動導至活動登入頁',
        type: 'info'
      }).then(function (result) {
        if (result.value) {
          const projectId = prjId
          const guideId = currentGuideId
          window.localStorage.clear()
          window.localStorage.setItem('RELOAD', 'Y')
          if (!_.isNil(guideId)) {
            window.localStorage.setItem('CURRENT_GUIDE_ID', guideId)
          }
          window.location.href = '/#/project/' + projectId
        }
      })
    } else if (_.isNull(window.localStorage.getItem('PROJECT_ID')) || (_.isNull(window.localStorage.getItem('QR_CODE')) && (prjId !== '822b5299-7d52-4520-ab0b-8d5a0c286298'))) {
      this.$swal({
        title: '找不到專案代碼與 QR Code',
        text: '系統將自動導至官網',
        type: 'error'
      }).then(function (result) {
        if (result.value) {
          window.location.href = window.localStorage.getItem('projectOfficialSite')
        }
      })
    } else {
      if (prjId !== '822b5299-7d52-4520-ab0b-8d5a0c286298') {
        const timeoutID = window.setInterval(
          () => {
            if (getCookie('follow-session') === null) {
              window.clearInterval(timeoutID)
              window.localStorage.removeItem('PROJECT_ID')
              window.localStorage.removeItem('QR_CODE')
              this.$swal({
                title: '感謝您參與這次的活動，使用時間已經結束',
                text: '系統將自動導至官網',
                type: 'info'
              }).then(function (result) {
                if (result.value) {
                  window.location.href = window.localStorage.getItem('projectOfficialSite')
                }
              })
            }
          }, 1000
        )
      }

      this.setProjectExtConfig()

      if (!_.isNil(this.$route.params.guideId)) {
        this.changeType('list')
        this.play()
      }

      if (prjId === '11b0255c-0477-4d72-a4e4-f8ee3b93535e') {
        this.displayType = 'button'
      }
    }
  },
  data: function () {
    return {
      prjId: '',
      displayType: 'map',
      guides: null,
      assetBaseUrl: 'https://follow.y2services.com/files/files/',
      playNum: '',
      guideNum: '',
      guideDesc: '',
      title: '',
      type: '',
      logo: '',
      mediaPath: '',
      videoId: '',
      classList: {
        active: false,
        hidden: true
      },
      playerVars: {
        autoplay: 1,
        controls: 0,
        iv_load_policy: 3,
        playsinline: 1
      },
      panelStatus: false,
      mapData: [],
      guideData: [],
      zoom: 18,
      center: [25.04366, 121.56057],
      startToLocale: false,
      url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
      attribution: `© <a href="http://osm.org/copyright">OpenStreetMap</a> contributors`,
      options: {
        zoomControl: true
      },
      icon: {
        type: {
          wc:
            '/images/icon_wc.png',
          wc_on:
            '/images/icon_wc_on.png',
          place:
            '/images/icon_place.png',
          place_on:
            '/images/icon_place_on.png',
          user:
            'https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-2x-blue.png'
        },
        shadowUrl:
          'https://cdnjs.cloudflare.com/ajax/libs/leaflet/0.7.7/images/marker-shadow.png',
        iconSize: [25, 41],
        wcIconSize: [25, 25],
        iconAnchor: [12, 41],
        wcIconAnchor: [12, 35],
        popupAnchor: [1, -34],
        wcPopupAnchor: [1, -34],
        shadowSize: [41, 41]
      },
      followListElementSize: this.followListElement
    }
  },
  methods: {
    ...mapMutations(['setProjectId', 'setQRCode', 'setAllMarkers', 'reloadGuides', 'setExtCustomInitLon', 'setExtCustomInitLat', 'setExtCustomPubUtils', 'setIsTrackingAllowed']),
    setProjectExtConfig () {
      Vue.axios.get('/config/project-config-ext.json').then((response) => {
        const data = response.data.filter(d => d.projectId === this.$route.params.prjId)
        if (!_.isNull(data) && !_.isEmpty(data)) {
          const projectConfig = data[0]
          // this.projectId = projectConfig.projectId
          // this.setProjectId(this.projectId)
          this.projectOfficialSite = projectConfig.projectOfficialSite
          window.localStorage.setItem('projectOfficialSite', this.projectOfficialSite)
          this.isQrCodeRequired = projectConfig.isQrCodeRequired
          const autoGenQRCode = 'followAppWebGen-' + uuid.v4()
          if (!this.isQrCodeRequired) {
            this.setQRCode(autoGenQRCode)
          }
          this.customizeBackGroundColor = projectConfig.customizeBackGroundColor
          this.customizeBackGroundImage = projectConfig.customizeBackGroundImage
          this.customizeLogo = projectConfig.customizeLogo
          this.customizeFooterText = projectConfig.customizeFooterText
          this.customizeInitialLongitude = projectConfig.customizeInitialLongitude
          this.setExtCustomInitLon(projectConfig.customizeInitialLongitude)
          this.customizeInitialLatitude = projectConfig.customizeInitialLatitude
          this.setExtCustomInitLat(projectConfig.customizeInitialLatitude)
          this.customizePublicUtilities = projectConfig.customizePublicUtilities
          window.localStorage.setItem('EXT_CUSTOM_PUB_UTILS', JSON.stringify(projectConfig.customizePublicUtilities))
          this.isClientBoxActive = true
          this.isLoginRequired = projectConfig.isLoginRequired
          this.isDataCollectionRequired = projectConfig.isDataCollectionRequired
          if (!projectConfig.isLoginRequired) {
            window.localStorage.setItem('userId', autoGenQRCode)
          }
        }
      }).then(() => {
        if (_.isNull(window.localStorage.getItem('ALL_MARKERS'))) {
          this.mapData = JSON.parse(window.localStorage.getItem('EXT_CUSTOM_PUB_UTILS'))
          Vue.axios.get('https://api.y2services.com/v1/guide/projectCode/' + this.$route.params.prjId).then((response) => {
            // this.$store.commit('reloadGuides', response.data)
            let guides = response.data
            let mapDataTemp = []
            if (!_.isNull(guides) && !_.isEmpty(guides)) {
              guides.forEach(
                row => row.guideContent.forEach(
                  item => {
                    item.logo = _.isEmpty(item.logo) ? '' : this.assetBaseUrl + item.logo.substr(0, 1) + '/' + item.logo.substr(1, 1) + '/' + item.logo
                    if (item.language === 'TW') {
                      item.local = [item.latitude, item.longitude]
                      item.cover = item.logo
                      item.name = item.title
                      item.id = row.guideCode
                      if (!mapDataTemp.includes(item)) {
                        mapDataTemp.push(item)
                      }
                    }
                  }
                )
              )
            }
            this.guides = guides
            // this.logo = guides[0].guideContent[0].logo
            this.reloadGuides(JSON.stringify(this.guides))
            // if (this.mapData.length < this.getExtCustomPubUtils.length + mapDataTemp.length) {
            for (const obj of mapDataTemp) {
              this.mapData.push(obj)
            }
            window.localStorage.setItem('ALL_MARKERS', JSON.stringify(this.mapData))
            // }
            // // console.log('response.data = ' + response.data.length)
            // // console.log('this.$store.state.guides = ' + this.$store.state.guides.length)
            // this.isPreloadReady = true
          })
            .catch((e) => {
              // // console.error(e)
            })
        } else {
          this.guides = JSON.parse(window.localStorage.getItem('GUIDE_LIST'))
          this.mapData = JSON.parse(window.localStorage.getItem('ALL_MARKERS'))
        }
      })
        .catch((e) => {
          // // console.error(e)
        })
    },
    openDetailPanel () {
      if (this.panelStatus) {
        this.classList.hidden = false
        this.classList.active = true
      } else {
        this.classList.active = false
      }
      if (this.startToLocale) {
        const trxDetail = {
          page: 'Follow',
          deviceFingerPrint: window.localStorage.getItem(LS_DEVICE_FINGER_PRINT_KEY),
          behavior: 'Open Detail Panel - ' + this.classList.active,
          latitude: this.center[0],
          longitude: this.center[1],
          deviceInfo: navigator.userAgent
        }

        const data = {
          qr_id: this.getQRCode,
          projectCode: this.getProjectId,
          trx_detail: JSON.stringify(trxDetail)
        }

        const config = {
          headers: {
            'content-type': 'application/x-www-form-urlencoded;charset=utf-8'
          }
        }

        Vue.axios.post('https://api.y2services.com/v1/guideqrinfo/add', this.Qs.stringify(data), config)
          .then((response) => {
          })
          .catch((e) => {
          })
      }
      if (this.type !== 'wav') {
        this.$refs.youtube.player.playVideo()
      }
    },
    closeDetailPanel () {
      if (this.type !== '' && this.type !== 'wav') {
        this.$refs.youtube.player.stopVideo()
      }

      this.classList.active = false
      if (this.startToLocale) {
        let trxDetail = {
          page: 'Follow',
          deviceFingerPrint: window.localStorage.getItem(LS_DEVICE_FINGER_PRINT_KEY),
          behavior: 'Open Detail Panel - ' + this.classList.active,
          latitude: this.center[0],
          longitude: this.center[1],
          deviceInfo: navigator.userAgent
        }

        const data = {
          qr_id: this.getQRCode,
          projectCode: this.getProjectId,
          trx_detail: JSON.stringify(trxDetail)
        }

        const config = {
          headers: {
            'content-type': 'application/x-www-form-urlencoded;charset=utf-8'
          }
        }

        Vue.axios.post('https://api.y2services.com/v1/guideqrinfo/add', this.Qs.stringify(data), config)
          .then((response) => {
          })
          .catch((e) => {
          })
      }
    },
    inputGuideNum (str) {
      this.guideNum = str === 'C' ? '' : this.guideNum + str
    },
    playByNum (num) {
      if (this.displayType === 'map') {
        const previousElement = document.querySelector('#playMarker')
        if (!_.isEmpty(previousElement)) {
          previousElement.removeAttribute('id')
          previousElement.setAttribute('src', previousElement.getAttribute('src').replace('_on.png', '.png'))
        }
        const element = document.querySelector('.leaflet-pane .leaflet-marker-pane > img[style$="none;"]')
        element.setAttribute('src', element.getAttribute('src').replace('.png', '_on.png'))
        element.setAttribute('id', 'playMarker')
      }
      this.guideNum = num
      this.play()
    },
    play () {
      this.playNum = this.guideNum
      const guideCode = this.guideNum
      const guideObj = _.find(this.guides, function (el) {
        return _.get(el, 'guideCode') === guideCode
      })
      if (_.isUndefined(guideCode) || _.isEmpty(guideCode)) {
        // this.$refs.audioElm.pause()
        // document.getElementById('playBoxBtn').classList.add('btn_play')
        // document.getElementById('playBoxBtn').classList.remove('btn_pause')
        // this.$swal.fire('導覽代碼錯誤', '請重新輸入導覽代碼', 'error')
        this.guideDesc = ''
        this.title = this.getShowLocalName
        this.type = ''
        this.logo = ''
        this.guideNum = ''
        this.panelStatus = false
        if (this.startToLocale) {
          let trxDetail = {
            page: 'Follow',
            deviceFingerPrint: window.localStorage.getItem(LS_DEVICE_FINGER_PRINT_KEY),
            behavior: 'Input wrong track number - ' + guideCode,
            latitude: this.center[0],
            longitude: this.center[1],
            deviceInfo: navigator.userAgent
          }

          const data = {
            qr_id: this.getQRCode,
            projectCode: this.getProjectId,
            trx_detail: JSON.stringify(trxDetail)
          }

          const config = {
            headers: {
              'content-type': 'application/x-www-form-urlencoded;charset=utf-8'
            }
          }

          Vue.axios.post('https://api.y2services.com/v1/guideqrinfo/add', this.Qs.stringify(data), config)
            .then((response) => {
            })
            .catch((e) => {
            })
        }
      } else {
        const desc = _.get(guideObj, 'guideContent[0].desc')
        const title = _.get(guideObj, 'guideContent[0].title')
        const type = _.get(guideObj, 'guideContent[0].type')
        this.guideDesc = desc
        this.title = title
        this.type = type
        const mediaPath = _.get(guideObj, 'guideContent[0].mediaPath')
        if (type === 'wav') {
          this.logo = _.get(guideObj, 'guideContent[0].logo')
          this.mediaPath = this.assetBaseUrl + mediaPath.substr(0, 1) + '/' + mediaPath.substr(1, 1) + '/' + mediaPath
          document.querySelector('#video-part').setAttribute('style', 'display:none')
          document.querySelector('#audio-img-part').removeAttribute('style')
          document.querySelector('#audio-part').removeAttribute('style')
          this.$refs.audioElm.src = this.mediaPath
          this.$refs.audioElm.play()
        } else {
          document.querySelector('#audio-img-part').setAttribute('style', 'display:none')
          document.querySelector('#audio-part').setAttribute('style', 'display:none')
          document.querySelector('#video-part').removeAttribute('style')
          this.mediaPath = _.get(guideObj, 'guideContent[0].mediaPath')
          this.videoId = _.split(mediaPath, '=')[1]
          // this.logo = 'http://img.youtube.com/vi/' + this.videoId + '/2.jpg'
          // document.getElementById('playBoxBtn').classList.remove('btn_pause')
          // document.getElementById('playBoxBtn').classList.remove('btn_play')
        }
        if (this.startToLocale) {
          let trxDetail = {
            page: 'Follow',
            deviceFingerPrint: window.localStorage.getItem(LS_DEVICE_FINGER_PRINT_KEY),
            behavior: 'Play track ',
            playTrack: this.guideNum,
            latitude: this.center[0],
            longitude: this.center[1],
            deviceInfo: navigator.userAgent
          }

          const data = {
            qr_id: this.getQRCode,
            projectCode: this.getProjectId,
            trx_detail: JSON.stringify(trxDetail)
          }

          const config = {
            headers: {
              'content-type': 'application/x-www-form-urlencoded;charset=utf-8'
            }
          }

          Vue.axios.post('https://api.y2services.com/v1/guideqrinfo/add', this.Qs.stringify(data), config)
            .then((response) => {
            })
            .catch((e) => {
            })
        }
        this.guideNum = ''
        this.panelStatus = true
        this.openDetailPanel()
      }
    },
    playCtl () {
      if (this.type === 'wav') {
        if (document.getElementById('playBoxBtn').classList.contains('btn_pause')) {
          this.$refs.audioElm.pause()
          document.getElementById('playBoxBtn').classList.add('btn_play')
          document.getElementById('playBoxBtn').classList.remove('btn_pause')
        } else {
          this.$refs.audioElm.play()
          document.getElementById('playBoxBtn').classList.add('btn_pause')
          document.getElementById('playBoxBtn').classList.remove('btn_play')
        }
      } else {
        document.getElementById('playBoxBtn').classList.remove('btn_pause')
        document.getElementById('playBoxBtn').classList.remove('btn_play')
      }
    },
    ready () {
      // this.$refs.youtube.player.playVideo()
    },
    changeType (type) {
      this.displayType = type
      this.reCenter()
      this.closeDetailPanel()
    },
    handleGPSError (error) {
      switch (error.code) {
        case error.PERMISSION_DENIED:
          alert('您沒有授權取得定位資訊，請至系統設定中開啟')
          break
        case error.POSITION_UNAVAILABLE:
          alert('目前您所在的位置無法取得定位資訊')
          break
        case error.TIMEOUT:
          alert('定位超過 60 秒，系統會繼續進行定位')
          break
        default:
          alert('裝置發生錯誤，無法取得您的定位資訊')
      }
    },
    reCenter () {
      this.$nextTick(function () {
        if (this.displayType === 'map' && this.$refs.location.mapObject !== undefined) {
          // 將目前的位置的標記點彈跳視窗打開
          this.$refs.location.mapObject.openPopup()
        }
      })
    },
    recurseNodes (element, fn) {
      for (let el of element.childNodes) {
        this.recurseNodes(el, fn)
        fn(el)
      }
    },
    // recurse through all the vue component nodes and ruyn the callback fn
    recurseChildren (component, fn) {
      if (Array.isArray(component)) {
        component.map(child => this.recurseChildren(child, fn))
      }
      if (
        component &&
        component.$children &&
        component.$children.length > 0
      ) {
        component.$children.map(child => this.recurseChildren(child, fn))
      }
      fn(component)
    },
    playByUrl (count) {
      if (count > 0 && !_.isNil(this.$route.params.guideId) && this.displayType === 'list' && this.playNum !== this.$route.params.guideId) {
        this.guideNum = this.$route.params.guideId
        const target = document.querySelector('#guide-' + this.$route.params.guideId)
        target.click()
      }
    },
    toExhibitionInfo () {
      window.localStorage.removeItem('CURRENT_GUIDE_ID')
      this.$router.push({ name: 'exhibition' })
    }
  },
  mounted () {
    var execPlayByUrl
    // let followList = this.$refs.followList
    // this.$watch(
    //   function () {
    //     return followList.children.length
    //   },
    //   (val, oval) => {

    //   }
    // )
    // 等地圖創建後執行
    this.$nextTick(function () {
      if (!_.isNil(this.$route.params.guideId) && this.displayType === 'list' && this.playNum !== this.$route.params.guideId) {
        this.guideNum = this.$route.params.guideId
        execPlayByUrl = setInterval(function (guideNum) {
          const target = document.querySelector('#guide-' + guideNum)
          if (!_.isNil(target)) {
            target.click()
            clearInterval(execPlayByUrl)
          }
        }, 500, this.guideNum)
      }
      if (navigator.geolocation) {
        // 獲得目前位置
        navigator.geolocation.watchPosition((position) => {
          const p = position.coords
          // 將中心點設為目前的位置
          this.center = [p.latitude, p.longitude]
          this.startToLocale = true
        }, this.handleGPSError, { timeout: 60000 })
      } else {
        alert('geolocation not support')
      }
    })
    if (!_.isNil(this.$route.params.prjId)) {
      this.setProjectId(this.$route.params.prjId)
    }
  },
  watch: {
    $route (to, from) {
      if (to !== from) {
        location.reload()
      }
    }
  }
}
</script>
